import React, {Component} from 'react';
import Styles from './style.css';
import cx from "classnames";
import {langRegister} from "../../services/langRegister";
import {salesChannelRegister} from "../../services/salesChannelRegister";
import {dataRegister} from "../../services/dataRegister";
import queryString from "query-string";

class SignupAdsFacebookCanvas extends Component {

    constructor(props) {
        super(props);
        this.state = {
            image: null,
            website: null,
            industry: null
        };
    };

    componentDidMount() {
        this._updateData();
    }

    componentWillReceiveProps(){
        this._updateData();
    }

    _updateData() {
        this.setState({
            industry: this.props.industry,
            image: this.props.image,
            website: this.props.website,
            region: salesChannelRegister.get("market")
        }, () => {
            console.log(this.state);
        });
    }

    _renderAdImage() {
        if (this.state.image) {
            return (
                <div className={Styles.imagesContainerItem}>
                    <div className={Styles.imagesContainerItemInner}>
                        {
                            <div style={{backgroundImage: "url(" + this.state.image.url + ")"}} className={Styles.imagesContainerItemInnerUploadImage}/>
                        }
                    </div>
                </div>
            )
        }
    }

    _renderText(item) {
        return langRegister.get("signup-ads", item);
    }

    render() {
        return (
            <div>
                {this._renderAdImage()}
                {
                    !this.state.website &&
                    <div className={Styles.contentContainerLeftFacebookItemAdLink}>
                        {this._renderText("item_60")}{this.state.region}
                    </div>
                }
                {
                    this.state.website &&
                    <div className={Styles.contentContainerLeftFacebookItemAdLink}>
                        {this.state.website}
                    </div>
                }
                <div className={Styles.contentContainerLeftFacebookItemAdIndustry}>
                    {this.state.industry}
                </div>
            </div>
        );
    }
}

export default SignupAdsFacebookCanvas;


// WEBPACK FOOTER //
// ./src/components/signup-ads-facebook-canvas/component.js